// iPhone, iPod or iPad (Safari or the home-screen app). Kept apart from the
// push client so screens in the main bundle can ask without pulling it in.
export function isIos() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ reports itself as a Mac; touch support gives it away.
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

// In a browser tab (Safari, Chrome iOS), not the home-screen app.
export function isIosTab() {
  if (!isIos() || navigator.standalone === true) return false;
  return window.matchMedia?.('(display-mode: standalone)').matches !== true;
}
